import { BaseTextInputComponent } from "../base-text-input/base-text-input.component";
import { BaseTextInputProps } from "../base-text-input/base-text-input.types";
import styles from "./text-field.styles.module.scss";

export type TextFieldProps = BaseTextInputProps;

export const TextFieldComponent = (props: TextFieldProps) => <BaseTextInputComponent
  rootClassName={styles.root}
  {...props}
/>;